import { render, staticRenderFns } from "./UploadProfileImage.vue?vue&type=template&id=42e85a2e&"
import script from "./UploadProfileImage.vue?vue&type=script&lang=js&"
export * from "./UploadProfileImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports